import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Link from '../common/TrackedLink';
import { productSearchUpdate } from '../../actions/productActions';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import FacetSection from './FacetSection';
import SearchResults from './SearchResults';
// import OptInPopup from "../components/OptInPopup";
import {PRODUCT_SELECTOR } from "../../constants/app";
import {dataLayerPush} from "../../utils";

class ProductSearchLanding extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mobileFilter: false
		};
	}

	componentDidUpdate() {
		const category = this.props.params.category;
		const query = this.props.location.query;
		productSearchUpdate(category, query);
	}

	handleClickMobileFilter() {
		if (this.state.mobileFilter === false) {
			this.setState({ mobileFilter: true });
		} else {
			this.setState({ mobileFilter: false });
		}
	}

	render() {
		return (
			<div className="product-search">
				<Helmet>
					<title>Find The Safe That's Right For You &#124; SentrySafe</title>
					<meta name="description" content="Designed with you in mind, our safes offer unique features to protect your most valuable items. Find the safe that\'s right for you." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Products" />
				</Breadcrumb>

				<section className="row">
					<div className="col sm-3 facets">
						<h1 className="title">
							Find the Safe That&rsquo;s Right For You
						</h1>
						<button
							className={ `filter-btn ${this.state.mobileFilter ? 'active' : ''}` }
							onClick={ this.handleClickMobileFilter.bind(this) }
						>
							Filter
						</button>
						<div className={ this.state.mobileFilter ? 'mobile-filter active' : 'mobile-filter' }>
							<div className="filter-header sm-show">
								<h2>Filter</h2>
								<Link to="/products" className="reset-filters">
									Reset
								</Link>
								<button
									className="close"
									onClick={ () => this.handleClickMobileFilter() }
								>
									<span className="fa fa-times" aria-hidden="true" />
								</button>
							</div>
							<FacetSection />
						</div>
					</div>
					<div className="col sm-9 results">
						<SearchResults />
					</div>
				</section>

				<section className="row header-callout red">
					<div className="col">
						<h2 className="title">
							Need help choosing a safe?
						</h2>
						<p className="descr">
							Use our <Link to={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET}>
							{PRODUCT_SELECTOR.TEXT}
						</Link> to find the safe that&rsquo;s
							right for you.
							<span className="d-block text-break-h uppercase">
								<span className="bg-gray-dark"> or </span> 
							</span>
							Check out our <Link to="buying-guide">Buying Guide</Link> to learn more.
						</p>
					</div>
				</section>
				{/*<OptInPopup />*/}
			</div>
		);
	}
};

export default ProductSearchLanding;


// WEBPACK FOOTER //
// ./src/pages/productSearch/ProductSearchLanding.js